export const baseInfoConfig = [
  { label: '系统硬件', prop: 'hwVer' },
  { label: '系统软件', prop: 'swVer' },
  { label: '序列号', prop: 'sn' },
  { label: 'IP地址', prop: 'ipAddr' },
  {
    label: '当前场景',
    prop: 'sceneType',
    list: ['工作场景', '公共场景'],
    format(v) {
      return this.list[v] || '--';
    }
  },
  { label: '传感器数量', prop: 'sensorCount' }
];

export const scheduler = {
  temp: null,
  tasks: {},
  add(id, fn) {
    this.tasks[id] = fn;
  },
  destroy() {
    this.tasks = {};
    document.addEventListener('click', this.temp);
  },
  exec(id) {
    const keys = Object.keys(this.tasks).filter(k => k !== id);
    keys.forEach(key => {
      if (typeof this.tasks[key] !== 'function') return;
      this.tasks[key]();
      delete this.tasks[key];
    });
  }
};
scheduler.temp = scheduler.exec.bind(scheduler);

export const units = ['PPM', 'vol%', 'LEL%', 'mg/m³', 'PPB'];

/**
 * 创建阈值子表头
 * @returns {{label: string, prop: string}[]}
 */
export function makeThresholdCols(disabled) {
  return [
    { type: 'input', label: 'H', prop: 'H', span: 24, disabled },
    { type: 'input', label: 'L', prop: 'L', span: 24, disabled },
    { type: 'input', label: 'STEL', prop: 'ST', span: 24, disabled },
    { type: 'input', label: 'TWA', prop: 'TW', span: 24, disabled },
    { type: 'input', label: 'MAC', prop: 'M', span: 24, disabled }
  ];
}

/**
 * 设备基础信息 数据处理
 * @param {data: {}} res
 */
export function baseInfoHandler(res) {
  if (!res || !res.data) return;
  const e = res.data;
  const validThreshold = v => ({ H: v.H, L: v.L, ST: v.ST, TW: v.TW, M: v.M });

  return {
    sensorSeq: e.sensorSeq,
    code: e.code,
    sensorName: e.name,
    version: e.version,
    fullScale: e.fullScall,
    unit: e.unit,
    sensorSn: e.sensorSn,
    currentParam: validThreshold(e.currentParam || {}),
    default1Param: validThreshold(e.default2Param || {}),
    default2Param: validThreshold(e.default1Param || {})
  };
}

function validData(data) {
  const params = [data.currentParam, data.default1Param, data.default2Param];
  return !params.some(data =>
    Object.keys(data || {}).some(e => {
      return !(data[e] === '' ? false : data[e] >= 0);
    })
  );
}

/**
 * 阈值设置接口
 * @returns 处理好的数据
 */
export function makeParams(data) {
  const res = {};

  res.sensorType = 1;
  res.sensors = data
    .map(e => ({
      sensorSeq: e.sensorSeq,
      code: e.code,
      unit: e.unit,
      currentParam: e.currentThreshold,
      default1Param: e.workThreshold,
      default2Param: e.commonThreshold
    }))
    .filter(e => validData(e));

  return res;
}
